<form [formGroup]="detalleTema">
  <section class="nuevo-tema">
    <p class="nuevo-tema-title !font-bold">Nuevo Tema</p>
    <button
      class="button-add"
      [disabled]="disabled"
      (click)="addNuevoTema($event)">
      <mat-icon>add</mat-icon>
    </button>
  </section>
  <section class="observaciones-archivos">
    <mat-slide-toggle
      formControlName="esRealizado"
      name="esRealizado"
      class="example-margin"
      [color]="'primary'"
      hideIcon="true"
      labelPosition="before">
      ¿Se llevó a cabo el acuerdo?
    </mat-slide-toggle>
    <mat-card class="mat-card-top grid grid-cols-1 gap-4">
      <div class="flex items-center space-x-2 m-4">
        <mat-form-field class="flex-grow">
          <mat-label>Observaciones</mat-label>
          <input
            (keydown)="onKeyDown($event)"
            formControlName="observaciones"
            name="observaciones"
            class="nuevo-catalogo-input"
            type="text"
            maxlength="4000"
            matInput
            placeholder="Observaciones" />
          <mat-hint align="end">
            {{ detalleTema.get("observaciones")?.value.length }} / 4000
          </mat-hint>
        </mat-form-field>

        <button
          class="min-w-min"
          mat-stroked-button
          [disabled]=""
          (click)="descargaBitacora()">
          DESCARGAR BITÁCORA
        </button>
      </div>
    </mat-card>
    <mat-card class="mat-card-top" style="padding: 1rem 0">
      <div class="padding-content" style="display: flex; gap: 1rem">
        <button
          mat-mini-fab
          disabled
          aria-label="Example icon button with a home icon">
          <mat-icon>attach_file</mat-icon>
        </button>
        <mat-card-title>Agregar Archivos</mat-card-title>
      </div>

   
      <div class="file-detail padding-content" *ngFor="let archivo of files;">
        <button
          (click)="verArchivo(archivo)"
          mat-mini-fab
          [disabled]="archivo.nuevo"
          color="primary"
          aria-label="Remove file">
          <mat-icon>remove_red_eye</mat-icon>
        </button>
        <button
          (click)="eliminarArchivo(archivo)"
          mat-mini-fab
          color="warn"
          aria-label="Delete file">
          <mat-icon>delete</mat-icon>
        </button>
        <span>{{ archivo.name.length > 20 && archivo.name.substring(0, 20) + "..." || archivo.name }}</span>

      </div>
      
      <mat-card-actions align="start" class="padding-content actions-files">
        <button mat-stroked-button (click)="seleccionarArchivos()">
          SELECCIONAR ARCHIVO(S)
        </button>
        <input
          type="file"
          id="fileInput"
          (change)="subirArchivos($event)"
          multiple
          style="display: none" />

        <button
          [disabled]="files.length <= 0 || disabled"
          (click)="dowloadFiles(files)"
          mat-stroked-button
          extended>
          <mat-icon>save_alt</mat-icon>
          DESCARGAR TODO
        </button>
      </mat-card-actions>
    </mat-card>

    <mat-card-actions align="end" class="nuevo-catalogo-actions !pl-0 !pr-0">
      <button
        mat-stroked-button
        class="!uppercase"
        (click)="cancelarGuardado()">
        Cancelar
      </button>
      <button
        mat-flat-button
        class="!uppercase"
        color="primary"
        (click)="guardarAcuerdo()">
        Guardar
      </button>
    </mat-card-actions>
  </section>
</form>
